import { useEffect, useState } from "react";
import "./position-bar.css";

const PositionBar = () => {
  const [activeSection, setActiveSection] = useState("home");

  useEffect(() => {
    const sections = ["home", "problem", "solutions", "features", "form"];
    const capabilitySections = [
      "solutions-01",
      "solutions-02",
      "solutions-03",
      "solutions-04",
      "solutions-05",
    ];
    
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const viewportHeight = window.innerHeight;
      const viewportMiddle = scrollY + viewportHeight / 2;
      let currentSection = "home";
      const threshold = viewportHeight * 0.3; // 30% of viewport as threshold

      for (const sectionId of capabilitySections) {
        const section = document.getElementById(sectionId);
        if (!section) continue;
        const rect = section.getBoundingClientRect();
        const sectionTop = rect.top + scrollY;
        const sectionBottom = sectionTop + rect.height;

        if (viewportMiddle >= sectionTop - threshold && viewportMiddle <= sectionBottom + threshold) {
          currentSection = "solutions";
          break;
        }
      }
      
      // Check each section from bottom to top (to get the most recent section)
      for (let i = sections.length - 1; i >= 0; i--) {
        const sectionId = sections[i];
        // For form section, also check for contact-us id or its parent section
        let section = document.getElementById(sectionId);
        if (sectionId === "form" && !section) {
          const contactUsAnchor = document.getElementById("contact-us");
          if (contactUsAnchor) {
            // Find the parent section element
            section = contactUsAnchor.closest('section') || document.querySelector('[data-contact-us="true"]');
          } else {
            section = document.querySelector('[data-contact-us="true"]');
          }
        }
        
        if (section) {
          // Use getBoundingClientRect for more accurate position (handles transforms, pinning, etc.)
          const rect = section.getBoundingClientRect();
          const sectionTop = rect.top + scrollY;
          const sectionBottom = sectionTop + rect.height;
          
          // Special handling for solutions: check if we're in capability section too
          if (sectionId === "solutions") {
            if (currentSection === "solutions") {
              break;
            }
          }
          
          // Check if viewport middle is within this section (with threshold)
          if (viewportMiddle >= sectionTop - threshold && viewportMiddle <= sectionBottom + threshold) {
            currentSection = sectionId;
            break;
          }
          
          // If we've scrolled past this section's top (with threshold)
          if (scrollY >= sectionTop - threshold) {
            // Check if there's a previous section
            if (i > 0) {
              const prevSectionId = sections[i - 1];
              let prevSection = document.getElementById(prevSectionId);
              if (prevSectionId === "form" && !prevSection) {
                const contactUsAnchor = document.getElementById("contact-us");
                if (contactUsAnchor) {
                  prevSection = contactUsAnchor.closest('section') || document.querySelector('[data-contact-us="true"]');
                } else {
                  prevSection = document.querySelector('[data-contact-us="true"]');
                }
              }
              
              if (prevSection) {
                const prevRect = prevSection.getBoundingClientRect();
                const prevSectionTop = prevRect.top + scrollY;
                // If we haven't reached previous section yet, current section is active
                if (scrollY < prevSectionTop - threshold) {
                  currentSection = sectionId;
                  break;
                }
              } else {
                // No previous section found, current section is active
                currentSection = sectionId;
                break;
              }
            } else {
              // This is the first section (home), it's active
            currentSection = sectionId;
            break;
            }
          }
        }
      }
      
      setActiveSection(currentSection);
    };

    // Check initial position
    handleScroll();
    
    // Use throttled scroll for better performance
    let ticking = false;
    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };
    
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    // For form section, also check for contact-us id or its parent section
    let section = document.getElementById(sectionId);
    if (sectionId === "form" && !section) {
      const contactUsAnchor = document.getElementById("contact-us");
      if (contactUsAnchor) {
        // Find the parent section element
        section = contactUsAnchor.closest('section') || document.querySelector('[data-contact-us="true"]');
      } else {
        section = document.querySelector('[data-contact-us="true"]');
      }
    }
    
    if (section) {
      const navbarHeight = 72; // Height of main navbar
      const elementPosition = section.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - navbarHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  const menuItems = [
    { id: "home", label: "Home" },
    { id: "problem", label: "Problem" },
    { id: "solutions", label: "Solutions" },
    { id: "features", label: "Features" },
    { id: "form", label: "Form" },
  ];

  return (
    <nav className="position-bar">
      {menuItems.map((item) => (
        <button
          key={item.id}
          className={`position-bar-item ${activeSection === item.id ? "active" : ""}`}
          onClick={() => scrollToSection(item.id)}
        >
          {item.label}
        </button>
      ))}
    </nav>
  );
};

export default PositionBar;

